'use strict';

exports.__esModule = true;
exports.default = exports.decorator = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJsAndroidFix = require('draft-js-android-fix');

var _Link = require('material-ui-icons/Link');

var _Link2 = _interopRequireDefault(_Link);

var _ToggleBlockType2 = require('../ToggleBlockType');

var _ToggleBlockType3 = _interopRequireDefault(_ToggleBlockType2);

var _decorator = require('./decorator');

var _decorator2 = _interopRequireDefault(_decorator);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

exports.decorator = _decorator2.default;
var LinkControl = (_temp2 = _class = function (_ToggleBlockType) {
  _inherits(LinkControl, _ToggleBlockType);

  function LinkControl() {
    var _temp, _this, _ret;

    _classCallCheck(this, LinkControl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _ToggleBlockType.call.apply(_ToggleBlockType, [this].concat(args))), _this), _this.addLink = function () {
      var linkTitle = void 0,
          linkUrl = void 0,
          linkTarget = void 0;
      var _this$props = _this.props,
          editorState = _this$props.editorState,
          onChange = _this$props.onChange;

      var currentEntity = _this.getCurrentEntity();

      var selectionText = _this.getSelectionText(editorState);

      if (!selectionText) {
        return;
      } else {
        linkTitle = selectionText;
      } // return;
      // const { currentEntity } = this.state;


      var selection = editorState.getSelection();

      if (currentEntity) {// const entityRange = getEntityRange(editorState, currentEntity);
        // selection = selection.merge({
        //   anchorOffset: entityRange.start,
        //   focusOffset: entityRange.end,
        // });
      }

      var entityKey = editorState.getCurrentContent().createEntity('LINK', 'MUTABLE', {
        url: linkUrl,
        target: linkTarget
      }).getLastCreatedEntityKey();

      var contentState = _draftJsAndroidFix.Modifier.replaceText(editorState.getCurrentContent(), selection, '' + linkTitle, editorState.getCurrentInlineStyle(), entityKey); // return;

      /**
       * В версии 0.11-alpha здесь ломается. 
       * https://draftjs.org/docs/v0-10-api-migration.html#content
       */


      var newEditorState = _draftJsAndroidFix.EditorState.push(editorState, contentState, 'insert-characters'); // return;
      // insert a blank space after link
      // selection = newEditorState.getSelection()
      // selection = newEditorState.getSelection().merge({
      //   anchorOffset: selection.get('anchorOffset') + linkTitle.length,
      //   focusOffset: selection.get('anchorOffset') + linkTitle.length,
      // });
      // newEditorState = EditorState.acceptSelection(newEditorState, selection);
      // contentState = Modifier.insertText(
      //   newEditorState.getCurrentContent(),
      //   selection,
      //   ' ',
      //   newEditorState.getCurrentInlineStyle(),
      //   undefined,
      // );


      onChange(_draftJsAndroidFix.EditorState.push(newEditorState, contentState, 'insert-characters')); // this.doCollapse();
    }, _this.toggleBlockType = function () {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          editorState = _this$props2.editorState,
          blockType = _this$props2.blockType; // this.addLink("test link", "https://modxclub.ru")
      // const newState = RichUtils.toggleBlockType(
      //   editorState,
      //   blockType,
      // );
      // if (newState) {
      //   onChange(newState);
      // }

      var action = _this.getCurrentAction();

      if (action) {
        return action();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LinkControl.prototype.getCurrentEntity = function getCurrentEntity() {
    var editorState = this.props.editorState;
    return this.getSelectionEntity(editorState); // if (editorState) {
    //   this.setState({
    //     currentEntity: getSelectionEntity(editorState),
    //   });
    // }
    // modalHandler.registerCallBack(this.expandCollapse);
  }; // addLink = (linkTitle, linkUrl, linkUrlOption) => {


  LinkControl.prototype.getCurrentAction = function getCurrentAction() {
    var action = void 0;
    var isSelected = this.isTextSelected();

    if (isSelected) {
      action = this.addLink;
    }

    return action;
  };

  LinkControl.prototype.isDisabled = function isDisabled() {
    var _props = this.props,
        disabled = _props.disabled,
        editorState = _props.editorState;
    var action = this.getCurrentAction();
    return disabled || !action;
  };

  LinkControl.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {}; // render() {
  //   const {
  //     editorState,
  //     onChange,
  //     blockType,
  //     icon: Icon,
  //     ...other
  //   } = this.props;
  //   return <IconButton
  //     onClick={() => this.toggleBlockType()}
  //     {...other}
  //   >
  //     <Icon />
  //   </IconButton>
  // }


  return LinkControl;
}(_ToggleBlockType3.default), _class.propTypes = _extends({}, _ToggleBlockType3.default.propTypes, {
  blockType: _propTypes2.default.string
}), _class.defaultProps = {
  icon: _Link2.default
}, _temp2);
exports.default = LinkControl;